import type { AccountInfo } from '@azure/msal-common';

function caseInsensitiveStingCompare(lhs: unknown, rhs: unknown): boolean {
    if (typeof lhs !== 'string' || typeof rhs !== 'string') return false;

    return lhs.toUpperCase() === rhs.toUpperCase();
}

export function getAccountByPolicy(
    accounts: AccountInfo[],
    policy: string
): AccountInfo | null {
    return (
        accounts.filter((account) =>
            caseInsensitiveStingCompare(account.idTokenClaims?.tfp, policy)
        )[0] ?? null
    );
}
